import {useState} from 'react';
import {
	IconButton,
	CircularProgress,
	Snackbar,
	Alert,
	Button,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import {searchByImage} from 'src/utils/AdminApi';
import {toast} from 'react-toastify';
import {toastUnexpectedError} from 'src/utils/toasts';
import {useQueryClient} from 'react-query';
import {Clear} from '@mui/icons-material';
import sendGAEvent from 'src/hooks/sendGAEvent';
import {Stack} from '@mui/system';

function SearchImage({queryKey, refetch, iconOnly = false, fullWidth = false}) {
	//   const router = useRouter();
	const [errorMessage, setErrorMessage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isUploaded, setIsUploaded] = useState(null);
	const [uploadedImagePreview, setUploadedImagePreview] = useState(null);
	const queryClient = useQueryClient();

	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

	const handleFileUpload = async (e) => {
		setIsLoading(true);
		const file = e.target.files[0];
		if (!file) return;

		// Basic validation
		if (!file.type.startsWith('image/')) {
			setErrorMessage('Please upload an image file');
			return;
		}

		setErrorMessage(null);

		try {
			const {products} = await searchByImage(file);
			setIsUploaded(true);
			setQueryData({
				pages: [products],
			});
			setUploadedImagePreview(URL.createObjectURL(file));

			sendGAEvent('image_search_usage', {
				result_count: products.length,
			});
		} catch (err) {
			toastUnexpectedError();
		}
		e.target.value = null;
		setIsLoading(false);
	};

	const handleCloseError = () => {
		setErrorMessage(null);
	};

	const setQueryData = (newData) => {
		// Update the data for your infinite query
		queryClient.setQueryData(queryKey, newData);
	};

	return (
		<Stack direction="row" alignItems="center">
			<input
				accept="image/*"
				style={{display: 'none'}}
				id="icon-button-file"
				type="file"
				onChange={handleFileUpload}
				disabled={isLoading}
			/>

			<label style={{height: '100%'}} htmlFor="icon-button-file">
				{iconOnly ? (
					<IconButton sx={{border: 'solid 1px #C4CDD5', borderRadius: 1.5}} component="span">
						{isLoading ? (
							<CircularProgress size={24} sx={{color: 'text.secondary', mr: 1}} />
						) : (
							<AddAPhotoIcon fontSize="medium" sx={{color: 'text.secondary'}} />
						)}
					</IconButton>
				) : (
					<Button
						fullWidth={fullWidth}
						component="span"
						variant="outlined"
						startIcon={<AddAPhotoIcon fontSize="medium" sx={{color: 'text.secondary'}} />}
						disabled={isLoading}
						sx={{
							color: 'text.secondary',
							borderColor: 'text.secondary',
							'&:hover': {borderColor: '#333333'},
						}}
					>
						{isLoading ? <CircularProgress size={24} sx={{color: 'text.secondary', mr: 1}} /> : null}
						البحث بالصورة
					</Button>
				)}
			</label>

			{uploadedImagePreview && (
				<img
					src={uploadedImagePreview}
					alt="الصورة المختارة"
					style={{
						width: 40,
						height: 40,
						objectFit: 'cover',
						borderRadius: '4px',
						marginLeft: '12px',
						marginRight: '12px',
						verticalAlign: 'middle',
					}}
				/>
			)}

			{isUploaded && (
				<IconButton
					onClick={() => {
						setIsUploaded(false);
						setUploadedImagePreview(null);
						refetch();
					}}
				>
					<Clear />
				</IconButton>
			)}

			<Snackbar
				open={!!errorMessage}
				autoHideDuration={6000}
				onClose={handleCloseError}
				anchorOrigin={{vertical: 'top', horizontal: 'center'}}
			>
				<Alert onClose={handleCloseError} severity="error" sx={{width: '100%'}}>
					{errorMessage}
				</Alert>
			</Snackbar>
		</Stack>
	);
}

export default SearchImage;
